import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=964a76e6&scoped=true"
import script from "./ModalIframe.vue?vue&type=script&lang=js"
export * from "./ModalIframe.vue?vue&type=script&lang=js"
import style0 from "./ModalIframe.vue?vue&type=style&index=0&id=964a76e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a76e6",
  null
  
)

export default component.exports